const GET_RENEWAL_POLICY = "/policy/details";
const GET_PPMC_DETAILS = "/policy/compute_ppmc";
const GET_BOOKING_DETAILS = '/tpa/get-appointment-booking-details';
const GET_TELE_BOOKING_DETAILS = '/tele/get-appointment-booking-details';
const GET_TELE_VH_SLOTS = '/tele/visit-slot-booking';
const GENERATE_ORDER_ID = '/v1/generate/orderid';
const GET_TPA_DETAILS = '/tpa/uw-brms';
const GET_TELE_TPA_DETAILS = '/tele/uw-brms';
const BOOK_TELE_APPOINTMENT = '/tele/uw-appointment-booking';
const BOOK_APPOINTMENT_HI = '/tpa/uw-appointment-booking-hi';
const BOOK_APPOINTMENT_HA = '/tpa/uw-appointment-booking-ha';
const BOOK_APPOINTMENT_VH = '/tpa/uw-appointment-booking-visit';
const GET_HA_DC_LIST = '/tpa/ha-dc-center-list';
const GET_HI_DC_LIST = '/tpa/hi-dc-center-list';
const GET_VH_DC_LIST = '/tpa/vh-dc-center-list';
const GET_PAYMENT_DOWNLOAD_API = "/policy/download";
const UPLOAD_DOCUMENT = "/policy/upload";
const GET_OTP_DETAILS = '/v1/getOTP';
const VERIFY_OTP_DETAILS = '/v1/validateOTP';
const JWT_LOGIN = '/api/enc/login';
const JWT_REFRESH = '/api/enc/refresh_token';
const HUMS_ACKNOWLEDGEMENT = '/tpa/hums_acknowledgement';
const SAVE_COUNTER_OFFER = '/v1/save/offer';
export { SAVE_COUNTER_OFFER, GET_TELE_VH_SLOTS, GET_TELE_BOOKING_DETAILS, BOOK_TELE_APPOINTMENT, GET_TELE_TPA_DETAILS, GENERATE_ORDER_ID, HUMS_ACKNOWLEDGEMENT, JWT_LOGIN, JWT_REFRESH, GET_RENEWAL_POLICY, GET_OTP_DETAILS, GET_PPMC_DETAILS, VERIFY_OTP_DETAILS, GET_VH_DC_LIST, BOOK_APPOINTMENT_HA, BOOK_APPOINTMENT_VH,  BOOK_APPOINTMENT_HI , GET_HA_DC_LIST, GET_HI_DC_LIST, GET_TPA_DETAILS, GET_PAYMENT_DOWNLOAD_API, UPLOAD_DOCUMENT, GET_BOOKING_DETAILS };
